import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { GruposEmpresaComponent } from './grupos-empresa.component';
import { GruposEmpresaDetailsComponent } from './grupos-empresa-details/grupos-empresa-details.component';
import { GruposEmpresaListComponent } from './grupos-empresa-list/grupos.empresa-list.component';
import { FuseShortcutsModule } from 'app/modules/fuse/components/shortcuts/shortcuts.module';

@NgModule({
    declarations: [
        GruposEmpresaComponent,
        GruposEmpresaListComponent,
        GruposEmpresaDetailsComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatFormFieldModule,
        MatInputModule,
        MatDialogModule,
        MatSelectModule,
        MatSnackBarModule,
        FuseShortcutsModule
    ],
    exports: [
        GruposEmpresaComponent
    ]
})
export class GruposEmpresaModule { } 